import alert from '@src/components/modal/alert';
import styles from './index.less';

/**
 * 提醒, 用法几乎等同 window.alert
 * @param {string} text - 提示文本
 * @param {number} [duration] - 展示 duration 毫秒后关闭
 * @param {object} [componentContext] - 组件环境变量, 当传入时可以再 componentContext 销毁时自动销毁当前组件
 */
export default function remind(text, duration, componentContext) {
  return alert(
    {
      title: text,
      duration,
      finalClassName: styles.root
    },
    componentContext
  );
}
